import { module } from 'modujs'
import { lazyLoadImage } from '../utils/image'
import LocomotiveScroll from 'locomotive-scroll'
import { $html } from '../utils/dom'

export default class extends module {
    constructor(m) {
        super(m);

         // Binding
         this.onScrollBind = this.onScroll.bind(this)
    }

    init() {
        this.scroll = new LocomotiveScroll({
            modularInstance: this,
            scrollCallback: this.onScrollBind,
        })

        // // Force scroll to top
        // if (history.scrollRestoration) {
        //     history.scrollRestoration = 'manual'
        //     window.scrollTo(0, 0)
        // }

        this.scroll.lenisInstance.options.content.addEventListener('wheel', (event) => {
            const targets = event.composedPath();

            const stopPropagation = targets.some(target => target.id === 'cc-main');
            if (stopPropagation) {
                event.stopPropagation();
            }
        });
    }

    ///////////////
    // Callbacks
    ///////////////
    onScroll({ scroll, velocity, progress }) {
        if(scroll > 400) {
            $html.classList.add('has-scrolled');
        } else {
            $html.classList.remove('has-scrolled');
        }
    }

    footerShow(args) {
        if (args.way === 'enter') {
            $html.classList.add('has-footer-show')
        }
        if (args.way === 'leave') {
            $html.classList.remove('has-footer-show')
        }
    }

    /**
     * Lazy load the related image.
     *
     * @see ../utils/image.js
     *
     * It is recommended to wrap your `<img>` into an element with the
     * CSS class name `.c-lazy`. The CSS class name modifier `.-lazy-loaded`
     * will be applied on both the image and the parent wrapper.
     *
     * ```html
     * <div class="c-lazy o-ratio u-4:3">
     *     <img data-scroll data-scroll-call="lazyLoad, Scroll, main" data-src="http://picsum.photos/640/480?v=1" alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
     * </div>
     * ```
     *
     * @param {LocomotiveScroll} args - The Locomotive Scroll instance.
     */
    lazyLoad(args) {
        lazyLoadImage(args.target, null, () => {
            //callback
        })
    }

    scrollTo(params) {
        let { target, options } = params

        options = Object.assign({
            // Defaults
            duration: 1,
        }, options)

        this.scroll?.scrollTo(target, options)
    }

    destroy() {
        this.scroll.destroy();
    }
}
